import {Button, Input, InputContainer} from 'finform';
import React, {useState} from 'react';
import {connect} from 'react-redux';

import {
    LoginFormInterface,
    SuccessCallbacksListInterface,
    handleLoginFailure,
    handleLoginSuccess,
    initialLoginFormState,
} from "#app/api";
import {Row} from '#app/components/layout/styles';
import {Container, HeaderForget, HeaderForgetContainer, Wrapper} from "#app/pages/Auth/styles";
import {login, handleForgotModal, handleCloseModal} from '#app/store/actions/auth';


import BaseFormContainer from './BaseFormContainer';

interface LoginProps {
    login: (payload: any) => void;
    handleForgotModal: () => void;
    handleCloseModal: () => void;
    callback?: () => void;
}

const FormOnLogin: React.FC<LoginProps> = ({
                                               login,
                                               handleForgotModal,
                                               handleCloseModal,
                                               callback
                                           }) => {
    const [form, setForm] = useState<LoginFormInterface>(initialLoginFormState);
    const [type, setType] = useState<string>('');
    const [_submitted, setSubmitted] = useState<boolean>(false);
    const [_checked, setChecked] = useState<boolean>(false);
    const [formErrors, setFormErrors] = useState<Record<string, string | null>>({});

    const getError = (fieldName: string): string | null => {
        return formErrors[fieldName] || null;
    };

    const handleInputChange = (field: string, value: string) => {
        setForm((prev) => ({...prev, [field]: value}));
        // Очищаем ошибку при изменении поля
        if (formErrors[field]) {
            setFormErrors((prev) => ({...prev, [field]: null}));
        }
    };

    const submitForm = () => {
        // Валидация
        const errors: Record<string, string | null> = {};
        
        if (!form.email || !form.email.trim()) {
            errors.email = 'Email обязателен';
        } else if (!form.email.includes('@')) {
            errors.email = 'Некорректный email';
        }
        
        if (!form.password || !form.password.trim()) {
            errors.password = 'Пароль обязателен';
        }
        
        if (type === '2fa' && (!form.code || !form.code.trim())) {
            errors.code = 'Код 2FA обязателен';
        }
        
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        
        setFormErrors({});
        setSubmitted(true);
        const successCallbacks: SuccessCallbacksListInterface = { handleCloseModal, setForm, setSubmitted, callback };
        login({
            form,
            success: (response: any, status: number, xhr: any) => handleLoginSuccess(
                {response, status, xhr}, successCallbacks
            ),
            error: (xhr: any, responseData: any) => {
                handleLoginFailure(type, responseData, setType, setSubmitted);
                // Устанавливаем ошибки из ответа сервера
                if (responseData?.errors) {
                    const serverErrors: Record<string, string | null> = {};
                    Object.keys(responseData.errors).forEach((key) => {
                        const errorMessages = responseData.errors[key];
                        serverErrors[key] = Array.isArray(errorMessages) ? errorMessages[0] : errorMessages;
                    });
                    setFormErrors(serverErrors);
                }
            },
            obj: {state: form, setState: (stateUpdater: any) => setForm((prev) => stateUpdater(prev))},
        });
    };

    const _handleCheckbox = () => setChecked((prev) => !prev);
    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            submitForm();
        }
    };

    return (
        <BaseFormContainer onSubmit={submitForm}>
            <Wrapper>
                <Container>
                    <Row>
                        <InputContainer error={getError('email')}>
                            <Input
                                id="login-email"
                                name="email"
                                onKeyDown={handleEnter}
                                autoComplete="on"
                                value={form.email}
                                onChange={(value) => handleInputChange('email', value as string)}
                                placeholder="Email"
                            />
                        </InputContainer>
                    </Row>
                    <Row>
                        <InputContainer error={getError('password')}>
                            <Input
                                id="login-password"
                                type="password"
                                name="password"
                                onKeyDown={handleEnter}
                                value={form.password}
                                onChange={(value) => handleInputChange('password', value as string)}
                                placeholder="Пароль"
                            />
                        </InputContainer>
                    </Row>
                    {type === '2fa' && (
                        <Row>
                            <InputContainer error={getError('code')}>
                                <Input
                                    id="login-code"
                                    type="text"
                                    name="code"
                                    value={form.code}
                                    onChange={(value) => handleInputChange('code', value as string)}
                                    placeholder="Код 2FA"
                                />
                            </InputContainer>
                        </Row>
                    )}
                    <Row>
                        <HeaderForgetContainer>
                            <HeaderForget
                                id="forgot-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleForgotModal();
                                }}
                            >
                                Забыли пароль?
                            </HeaderForget>
                        </HeaderForgetContainer>
                    </Row>
                    <Row>
                        <Button wide id="login-submit" onClick={submitForm}>
                            Войти
                        </Button>
                    </Row>
                </Container>
            </Wrapper>
        </BaseFormContainer>
    );
};

const enhance = connect(
    (_state: any) => ({}),
    {login, handleForgotModal, handleCloseModal}
);

export {FormOnLogin};
export default enhance(FormOnLogin);